<template>
  <div id="app">
    <Header v-if="!isAdminPage" />
    <router-view />
    <Footer v-if="!isAdminPage" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    isAdminPage() {
      return this.$route.path === '/login' || this.$route.path === '/admin'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>